import React from 'react';
import TemplateVariablesList from 'src/components/TemplateVariablesList';
import { Text } from '@chakra-ui/react';

const TemplateVariablesTest: React.FC = () => (
  <div style={{ maxWidth: '20rem', margin: '0 auto' }}>
    <Text textStyle="headingGroup" mb={1}>
      Personalized variables
    </Text>
    <Text textStyle="textBody" mb={8}>
      Personalize your email using the variables provided.
    </Text>
    <TemplateVariablesList />
  </div>
);

export default TemplateVariablesTest;
